import { REFRESH_PROFILE_TEMP_SUCCESS } from './types';

const refreshProfileTempSuccess = (result) => ({
    type: REFRESH_PROFILE_TEMP_SUCCESS,
    payload: { ...result },
});

export { refreshProfileTempSuccess };
